import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom';
import ReactPaginate from "react-paginate";

export default function PendingChallenge() {
    const beckendLocalApiUrl = process.env.REACT_APP_BACKEND_LOCAL_API;
    const beckendLiveApiUrl = process.env.REACT_APP_BACKEND_LIVE_API;
    const nodeMode = process.env.NODE_ENV;
    
    const baseUrl = nodeMode === "development" ? beckendLocalApiUrl : beckendLiveApiUrl;

    const [challenge, setchallenge] = useState([])
    const [limit, setLimit] = useState(10);
    const [pageNumber, setPageNumber] = useState(1); // Start from 1 for consistency
    const [numberOfPages, setNumberOfPages] = useState(0);

    const setpageLimit = (event) => {
        setLimit(event.target.value);
        setPageNumber(1);
    }

    const handlePageClick = (data) => {
        setPageNumber(data.selected + 1);
    };

    const fetchPendingData = async () => {
        const access_token = localStorage.getItem('token')
        const headers = { Authorization: `Bearer ${access_token}` }
        
        axios.get(`${baseUrl}challange/pending_challange?page=${pageNumber}&_limit=${limit}`, { headers })
            .then((res) => {
                setchallenge(res.data.status || []);
                setNumberOfPages(res.data.totalPages || 0);
            })
            .catch(err => console.log(err))
    }

    const dateFormat = (e) => {
        if (!e) return "N/A";
        const date = new Date(e);
        return date.toLocaleString('default', { month: 'short', day: 'numeric', hour: 'numeric', hour12: true, minute: 'numeric' });
    }

    useEffect(() => {
        fetchPendingData();
    }, [pageNumber, limit])

    return (
        <div className="pending-challenges-container p-2 p-md-4">
            <style>{`
                .pending-challenges-container { background: #f0f2f5; min-height: 100vh; font-family: 'Poppins', sans-serif; }
                .header-card { background: #fff; padding: 20px; border-radius: 20px; box-shadow: 0 10px 30px rgba(0,0,0,0.05); margin-bottom: 25px; display: flex; flex-direction: column; gap: 15px; }
                
                @media (min-width: 768px) {
                    .header-card { flex-direction: row; justify-content: space-between; align-items: center; padding: 25px; }
                }

                .table-card-v2 { background: #ffffff; border-radius: 25px; overflow: hidden; box-shadow: 0 15px 35px rgba(0,0,0,0.1); border: none; }
                .table-banner-dark { background: linear-gradient(45deg, #1e293b, #334155); color: #ffffff !important; padding: 18px 25px; font-weight: 700; font-size: 1.1rem; }
                
                .table-responsive-custom { width: 100%; overflow-x: auto; -webkit-overflow-scrolling: touch; background: #fff; }
                .custom-table-pending { width: 100%; border-collapse: collapse; min-width: 850px; table-layout: auto; }
                
                .custom-table-pending th { background: #f8f9fa; color: #334155 !important; padding: 15px; font-weight: 800; text-transform: uppercase; font-size: 0.75rem; border-bottom: 2px solid #edf2f7; text-align: center; white-space: nowrap; }
                .custom-table-pending td { padding: 15px; vertical-align: middle; border-bottom: 1px solid #f1f1f1; font-size: 0.85rem; color: #000 !important; text-align: center; font-weight: 600; white-space: nowrap; }
                
                .id-badge { background: #f4eff5; color: #57155a !important; padding: 5px 10px; border-radius: 8px; font-family: monospace; font-size: 0.8rem; }
                .amount-text { color: #15803d !important; font-weight: 800; font-size: 1rem; }
                .status-badge-pending { background: #fff3e0; color: #e65100 !important; padding: 6px 12px; border-radius: 10px; font-weight: 700; font-size: 0.7rem; text-transform: uppercase; border: 1px solid #ffe0b2; }
                
                .btn-view-challenge { background: #57155a; color: white !important; border-radius: 10px; font-weight: 700; font-size: 0.8rem; padding: 8px 20px; border: none; transition: 0.3s; text-decoration: none; display: inline-block; }
                .btn-view-challenge:hover { transform: translateY(-2px); box-shadow: 0 5px 15px rgba(87, 21, 90, 0.3); }

                .pagination-challenge .page-link { border-radius: 10px !important; margin: 0 4px; background: #fff; color: #1e293b; font-weight: 600; border: none; box-shadow: 0 2px 5px rgba(0,0,0,0.05); padding: 8px 16px; }
                .pagination-challenge .page-item.active .page-link { background: #57155a !important; color: #fff !important; }
            `}</style>

            <div className="header-card">
                <div>
                    <h3 className="m-0" style={{fontWeight: 900, color: '#1e293b'}}>Challenge <span style={{color: '#57155a'}}>Waitlist</span></h3>
                    <p className="text-muted m-0" style={{fontSize: '0.85rem'}}>Reviewing and managing pending battle requests</p>
                </div>
                <div className="d-flex align-items-center gap-2">
                    <label className="m-0 mr-2 font-weight-bold" style={{fontSize: '0.8rem', color: '#57155a'}}>Limit:</label>
                    <select className='form-control form-control-sm' style={{width: '100px', borderRadius: '8px', fontWeight: 'bold', border: '2px solid #edf2f7'}} onChange={setpageLimit} value={limit}>
                        <option value="10">10</option>
                        <option value="20">20</option>
                        <option value="50">50</option>
                        <option value="100">100</option>
                    </select>
                </div>
            </div>

            <div className="table-card-v2">
                <div className="table-banner-dark">⏳ Pending Challenges Database</div>
                <div className="table-responsive-custom">
                    <table className="custom-table-pending">
                        <thead>
                            <tr>
                                <th style={{width: '60px'}}>#</th>
                                <th>Challenge ID</th>
                                <th>Creator Name</th>
                                <th>Battle Amount</th>
                                <th>Current Status</th>
                                <th>Created Date</th>
                                <th style={{width: '150px'}}>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {challenge && challenge.length > 0 ? challenge.map((game, key) => (
                                <tr key={game._id}>
                                    <td style={{color: '#64748b'}}>#{(pageNumber - 1) * limit + (key + 1)}</td>
                                    <td><span className="id-badge">{game._id}</span></td>
                                    <td style={{fontWeight: 700}}>{game.Created_by?.Name || 'Unknown'}</td>
                                    <td><span className="amount-text">₹{game.Game_Ammount}</span></td>
                                    <td><span className="status-badge-pending">{game.Status}</span></td>
                                    <td style={{fontSize: '0.75rem', color: '#64748b'}}>{dateFormat(game.createdAt)}</td>
                                    <td>
                                        <Link className="btn-view-challenge" to={`/view/${game._id}`}>
                                            <i className="fa fa-eye mr-2"></i>View Details
                                        </Link>
                                    </td>
                                </tr>
                            )) : (
                                <tr>
                                    <td colSpan="7" className="text-center py-5" style={{color: '#94a3b8', fontSize: '1.1rem'}}>
                                        No pending challenges found at the moment.
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>

            <div className='mt-4'>
                <ReactPaginate
                    previousLabel={"← Prev"}
                    nextLabel={"Next →"}
                    pageCount={numberOfPages}
                    onPageChange={handlePageClick}
                    containerClassName={"pagination pagination-challenge justify-content-center flex-wrap"}
                    pageClassName={"page-item"}
                    pageLinkClassName={"page-link shadow-sm"}
                    activeClassName={"active"}
                    forcePage={pageNumber - 1}
                />
            </div>
        </div>
    )
}
